var render = function render() {
        var _vm = this,
            _c = _vm._self._c;return _c('div', { staticClass: "keylist" }, [_c('p', [_vm._v("\n    当前页面 key 值使用情况(未包含二次依赖key，置灰代表未分配该权限)\n  ")]), _vm._v(" "), _c('div', { staticClass: "route-key" }, [_vm._v("页面入口 key：" + _vm._s(_vm.routeKey))]), _vm._v(" "), _c('ul', _vm._l(_vm.keys, function (item) {
                return _c('li', { key: item }, [_c('span', { class: {
                                'has-not-permission': _vm.roles.indexOf(item) === -1 } }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])]);
        }), 0)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };